import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M23.1,5.8h-8.7V2h-3.8v3.8H1.9C0.9,5.8,0,6.7,0,7.8v13.5c0,1.1,0.9,1.9,1.9,1.9h21.2c1,0,1.9-0.9,1.9-1.9V7.8 C25,6.7,24.1,5.8,23.1,5.8z M7.5,9c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5S5,12.9,5,11.5C5,10.1,6.1,9,7.5,9z M11.9,19H3v-0.5 C3,16.1,5.1,14,7.5,14s4.4,2.1,4.4,4.5V19z M22,19h-8v-1h8V19z M22,16h-8v-1h8V16z M22,13h-8v-1h8V13z" />
    </g>
  </svg>
);
